import { useFeatureStore } from "../../store/useFeatureStore";

const DEFAULT_TIMEOUT_MS = 15_000;

/** Wait until Firebase remote config flags are loaded (deeplink may run before init finishes). */
export function waitForFeatureStoreInit(
  timeoutMs = DEFAULT_TIMEOUT_MS,
): Promise<boolean> {
  if (useFeatureStore.getState().isInitialized) {
    return Promise.resolve(true);
  }

  return new Promise((resolve) => {
    const timeout = setTimeout(() => {
      unsub();
      console.warn(
        "[BridgeCourseDeeplink] remote config init timed out",
        { timeoutMs },
      );
      resolve(false);
    }, timeoutMs);

    const unsub = useFeatureStore.subscribe((state) => {
      if (state.isInitialized) {
        clearTimeout(timeout);
        unsub();
        resolve(true);
      }
    });

    if (useFeatureStore.getState().isInitialized) {
      clearTimeout(timeout);
      unsub();
      resolve(true);
    }
  });
}
